"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _reactTransitionGroup = require("react-transition-group");

var _popoverContainer = require("./popover-container.style");

var _icon = _interopRequireDefault(require("../icon"));

var _guid = _interopRequireDefault(require("../../utils/helpers/guid"));

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const paddingPropTypes = (0, _utils.filterStyledSystemPaddingProps)(_propTypes2.default.space);

const PopoverContainer = ({
  children,
  title,
  position,
  open,
  onOpen,
  onClose,
  renderOpenComponent,
  renderCloseComponent,
  shouldCoverButton,
  ariaDescribedBy,
  ...rest
}) => {
  const isControlled = open !== undefined;
  const [isOpenInternal, setIsOpenInternal] = (0, _react.useState)(false);
  const closeButtonRef = (0, _react.useRef)();
  const openButtonRef = (0, _react.useRef)();
  const guid = (0, _react.useRef)((0, _guid.default)());
  const popoverContainerId = `PopoverContainer_${guid.current}`;
  const isOpen = isControlled ? open : isOpenInternal;
  (0, _react.useEffect)(() => {
    if (isOpen && closeButtonRef.current) closeButtonRef.current.focus();
  }, [isOpen]);

  const handleOpenButtonClick = e => {
    if (!isControlled) setIsOpenInternal(!isOpen); // We want the open button to close the popover if it is already open

    if (!isOpen) {
      if (onOpen) onOpen(e);
    } else if (onClose) onClose(e);
  };

  const handleCloseButtonClick = e => {
    if (!isControlled) setIsOpenInternal(!isOpen);
    if (onClose) onClose(e);
    if (isOpen && openButtonRef.current) openButtonRef.current.focus();
  };

  const renderOpenComponentProps = {
    tabIndex: isOpen ? -1 : 0,
    isOpen,
    dataElement: "popover-container-open-component",
    onClick: handleOpenButtonClick,
    ref: openButtonRef,
    ariaLabel: title
  };
  const renderCloseComponentProps = {
    dataElement: "popover-container-close-component",
    tabIndex: 0,
    onClick: handleCloseButtonClick,
    ref: closeButtonRef,
    ariaLabel: "close"
  };
  return /*#__PURE__*/_react.default.createElement(_popoverContainer.PopoverContainerWrapperStyle, {
    "data-component": "popover-container",
    "aria-labelledby": popoverContainerId
  }, renderOpenComponent(renderOpenComponentProps), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.Transition, {
    in: isOpen,
    timeout: {
      exit: 300
    },
    appear: true,
    mountOnEnter: true,
    unmountOnExit: true
  }, state => /*#__PURE__*/_react.default.createElement(_popoverContainer.PopoverContainerContentStyle, _extends({
    "data-element": "popover-container-content",
    role: "dialog",
    animationState: state,
    position: position,
    shouldCoverButton: shouldCoverButton,
    "aria-labelledby": popoverContainerId,
    "aria-describedby": ariaDescribedBy,
    p: "16px 24px"
  }, (0, _utils.filterStyledSystemPaddingProps)(rest)), /*#__PURE__*/_react.default.createElement(_popoverContainer.PopoverContainerHeaderStyle, null, /*#__PURE__*/_react.default.createElement(_popoverContainer.PopoverContainerTitleStyle, {
    id: popoverContainerId,
    "data-element": "popover-container-title"
  }, title), renderCloseComponent(renderCloseComponentProps)), children)));
};

PopoverContainer.propTypes = { ...paddingPropTypes,

  /** A function that will render the open component
   *
   * `({dataElement, tabIndex, onClick, ref, ariaLabel, isOpen}) => ()`
   *
   */
  renderOpenComponent: _propTypes.default.func,

  /** A function that will render the close component
   *
   * `({dataElement, tabIndex, onClick, ref, ariaLabel, isOpen}) => ()`
   *
   */
  renderCloseComponent: _propTypes.default.func,

  /** If `true` the popover-container will open */
  open: _propTypes.default.bool,

  /** Sets the popover-container title displayed in the dialog */
  title: _propTypes.default.string,

  /** If `true` the popover-container will cover open button */
  shouldCoverButton: _propTypes.default.bool,

  /** Callback fires when open component is clicked */
  onOpen: _propTypes.default.func,

  /** Callback fires when close component is clicked */
  onClose: _propTypes.default.func,

  /** Sets rendering position of the popover-container */
  position: _propTypes.default.oneOf(["left", "right"]),

  /** The content of the popover-container */
  children: _propTypes.default.node,

  /** The id of the element that describes the dialog */
  ariaDescribedBy: _propTypes.default.string
};
PopoverContainer.defaultProps = {
  position: "right",
  shouldCoverButton: false,
  renderOpenComponent: ({
    // eslint-disable-next-line react/prop-types
    tabIndex,
    onClick,
    dataElement,
    ref,
    ariaLabel
  }) => /*#__PURE__*/_react.default.createElement(_popoverContainer.PopoverContainerOpenIcon, {
    tabIndex: tabIndex,
    onAction: onClick,
    "data-element": dataElement,
    ref: ref,
    "aria-label": ariaLabel,
    "aria-haspopup": true
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "settings"
  })),
  renderCloseComponent: ({
    // eslint-disable-next-line react/prop-types
    dataElement,
    tabIndex,
    onClick,
    ref,
    ariaLabel
  }) => /*#__PURE__*/_react.default.createElement(_popoverContainer.PopoverContainerCloseIcon, {
    "data-element": dataElement,
    tabIndex: tabIndex,
    onAction: onClick,
    ref: ref,
    "aria-label": ariaLabel
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "close"
  }))
};
var _default = PopoverContainer;
exports.default = _default;